import { Styles } from "../../../../types/common";

const styles: Styles = {
  label: {
    fontSize: "14px",
    color: "#54565A",
    marginBottom: "6px",
  },
  radioBox: {
    "& .radio_group": {
      justifyContent: "space-between",
      gap: "16px",
      "&.MuiFormGroup-row": {
        flexDirection: { xs: "column", sm: "row" },
      },
    },
  },
};

export default styles;
